import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-回访管理",
  "use": "icon-回访管理-usage",
  "viewBox": "0 0 160 160",
  "content": "<symbol viewBox=\"0 0 160 160\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-回访管理\">\n<path d=\"M28 13H132C138.075 13 143 17.9249 143 24V114.279C143 120.354 138.075 125.279 132 125.279H113.058C108.093 125.279 103.29 127.038 99.4987 130.243L88.3231 139.692C84.3117 143.084 78.4617 143.166 74.3568 139.888L61.8107 129.87C58.0894 126.898 53.4687 125.279 48.7065 125.279H28C21.9249 125.279 17 120.354 17 114.279V24C17 17.9249 21.9249 13 28 13Z\" stroke-width=\"10\" />\n<path d=\"M97.4298 40.8L115.231 56.5C116.614 57.719 115.751 60 113.909 60H44.8\" stroke-width=\"10\" stroke-linecap=\"round\" />\n<path d=\"M63.3701 102.4L45.5685 86.7C44.1864 85.481 45.0485 83.2 46.8914 83.2L116.8 83.2\" stroke-width=\"10\" stroke-linecap=\"round\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/回访管理.svg
// module id = ZN0F
// module chunks = 26